/** Reverse sorting order for columns. */
export const reverseSortingOrder = ['desc', 'asc', null];
